var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#EEFDF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2643 16.7173C26.0543 16.4698 25.7693 16.3198 25.4618 16.2898C24.0893 16.1473 22.7543 15.7498 21.5168 15.1273C21.3593 15.0448 21.1793 15.0073 21.0068 15.0073C20.8343 15.0073 20.6543 15.0448 20.4968 15.1273C19.2668 15.7498 17.9393 16.1473 16.5743 16.2898C16.2668 16.3198 15.9668 16.4623 15.7568 16.6948C15.5393 16.9273 15.4118 17.2348 15.4043 17.5648V20.7523C15.4043 25.0423 19.6043 27.7573 20.9993 27.7573C22.3943 27.7573 26.5943 25.0498 26.5943 20.7523V17.5648C26.5943 17.2573 26.4668 16.9498 26.2568 16.7248H26.2643V16.7173Z",
    fill: "#1ECCB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.6dc94ace553c6f1ef5f9e694e8d52f9c.svg";
export { ForwardRef as ReactComponent };